import { Navigate, useNavigate, useParams } from 'react-router-dom';
import PageTitle from '@/components/PageTitle';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import UsersTab from '../Users';
import GroupsTab from './GroupsTab';
import CoverageTab from './CoverageTab';
import PreviewTab from './PreviewTab';

export const SECURITY_BASE_PATH = '/security';

const TABS = [
  { value: 'users', label: 'Users' },
  { value: 'groups', label: 'Groups' },
  { value: 'coverage', label: 'Coverage' },
  { value: 'preview', label: 'Preview access' },
] as const;

type SecurityTab = (typeof TABS)[number]['value'];

/**
 * Security & Governance (admin only). Each tab is addressable at
 * /security/<tab> so it can be linked to directly.
 */
export default function SecurityGovernance() {
  const { tab } = useParams<{ tab: string }>();
  const navigate = useNavigate();

  if (!TABS.some((t) => t.value === tab)) {
    return <Navigate to={`${SECURITY_BASE_PATH}/users`} replace />;
  }

  return (
    <div className="p-8">
      <PageTitle title="Security & Governance" className="mb-4" />
      <Tabs value={tab as SecurityTab} onValueChange={(next) => navigate(`${SECURITY_BASE_PATH}/${next}`)}>
        <TabsList className="mb-4">
          {TABS.map((t) => (
            <TabsTrigger key={t.value} value={t.value}>{t.label}</TabsTrigger>
          ))}
        </TabsList>
        <TabsContent value="users">
          <UsersTab />
        </TabsContent>
        <TabsContent value="groups">
          <GroupsTab />
        </TabsContent>
        <TabsContent value="coverage">
          <CoverageTab />
        </TabsContent>
        <TabsContent value="preview">
          {/* Mounted only on this tab: while mounted it sends Plb-View-As on every request. */}
          {tab === 'preview' && <PreviewTab />}
        </TabsContent>
      </Tabs>
    </div>
  );
}
